import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/download-pdf.svg";
var DownloadPdfSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DownloadPdfSolid_default as default
};
